/**
 * PlayerList - Shows connected players
 */

import { useSimulationStore } from '../stores/simulationStore';
import { CollapsiblePanel } from './ui';

interface PlayerListProps {
  onSelectCreature: (creatureId: string) => void;
}

export function PlayerList({ onSelectCreature }: PlayerListProps) {
  const players = useSimulationStore((state) => state.players);
  const connectedCount = useSimulationStore((state) => state.connectedCount);
  const mySessionId = useSimulationStore((state) => state.sessionId);

  return (
    <CollapsiblePanel id="player-list" title={`Jugadores (${connectedCount})`} defaultCollapsed>

      {players.length === 0 ? (
        <p className="empty-text">Sin jugadores conectados</p>
      ) : (
        <ul className="players">
          {players.map((player) => (
            <li
              key={player.sessionId}
              className={`player-item ${player.sessionId === mySessionId ? 'me' : ''} ${
                player.isConnected ? 'connected' : 'disconnected'
              }`}
            >
              <div className="player-info">
                <span className="player-status-dot" />
                {player.image && (
                  <img src={player.image} alt="" className="player-avatar" />
                )}
                <span className="player-name">
                  {player.displayName}
                  {player.sessionId === mySessionId && ' (Tu)'}
                </span>
              </div>
              {player.creatureId ? (
                <button
                  className="view-creature-btn"
                  onClick={() => onSelectCreature(player.creatureId!)}
                  title="Ver criatura"
                >
                  Ver
                </button>
              ) : (
                <span className="no-creature">Sin criatura</span>
              )}
            </li>
          ))}
        </ul>
      )}
    </CollapsiblePanel>
  );
}
